/*
 * Author: Dw
 * File Created: Friday, 24-08-02 03:46 pm
 * Last Modified: Thursday, 25-03-06 11:08 am, by Ben Zhao
 */

import { useRouter } from 'next/router';
import { i18n } from 'next-i18next';

import { connectUrl, cookies } from '@web/utils';

import { modifyLanguage } from '@/services/account/service';
import { useUserStore } from '@/stores/useUserStore';

export type LanguageType = 'zh' | 'en';

const useLanguage = () => {
  const router = useRouter();
  const lang = (router.locale ?? 'en') as LanguageType;
  const isLogin = useUserStore((state) => state.isLogin);
  const query = router.query;

  const setLocale = (language: string, pathname?: string) => {
    void i18n?.changeLanguage(language);
    cookies.set('NEXT_LOCALE', language);
    if (isLogin) {
      void modifyLanguage({ language: language === 'zh' ? 'CN' : 'EN' });
    }

    if (pathname) {
      void router.push(connectUrl(pathname, query), undefined, {
        locale: language,
      });
    } else {
      void router.replace(connectUrl(router.asPath, router.query), undefined, {
        locale: language,
      });
    }
  };

  return {
    curLocale: lang,
    setLocale,
  };
};

export default useLanguage;
